import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';

import { BrandsEnum, IMedia } from '@seb/web-design-system/core';

@Injectable({
  providedIn: 'root'
})
export class HobMapper {
  constructor(private route: ActivatedRoute) {}

  currentBrandToBrandEnum(defaultBrand?: string): BrandsEnum {
    if (this.route.snapshot?.children?.length > 0) {
      // TODO-EL: ATTENTION la brand peut être en seconde position (voir baseSite urlEncodingAttributes)
      const brand = this.route.snapshot?.children[0]?.url[0]?.path;

      switch (brand?.toLowerCase()) {
        case 'calor':
          return BrandsEnum.calor;
        case 'krups':
          return BrandsEnum.krups;
        case 'tefal':
          return BrandsEnum.tefal;
        case 'moulinex':
          return BrandsEnum.moulinex;
        case 'rowenta':
          return BrandsEnum.rowenta;
        case 'seb':
          return BrandsEnum.seb;
      }
    }

    return (defaultBrand ?? BrandsEnum.default) as BrandsEnum;
  }

  getBrandLogoTitle(brand: string): IMedia {
    const logoBrand = brand?.toLowerCase();

    if (logoBrand) {
      return {
        url: `assets/icons/commons/icon-card-brand-${logoBrand}.svg`,
        altText: brand,
        mime: 'image/svg+xml'
      };
    }

    return null;
  }

  toBrandEnum(id: string): BrandsEnum {
    return BrandsEnum[id.toLowerCase()];
  }
}
